import { apiAuth } from "../../http";

export const patchPostById = async (id: string, body: any): Promise<any> => {
  const response = apiAuth()
    .patch(`/posts/${id}`, body)
    .then(({ data }) => data);
  return response;
};
